;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.order.show')
    .controller('CloseOrderController', CloseOrderController)

  CloseOrderController.$inject = ['$uibModalInstance']

  function CloseOrderController ($uibModalInstance) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        // Public Methods
        refuse: refuse,
        accept: accept,
        cancel: cancel
      })
    }

    function refuse () {
      $uibModalInstance.close(false)
    }

    function accept () {
      $uibModalInstance.close(true)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }
  }
})(window.angular, window._)
